function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_105_50124)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.363 119.234H32.6368C29.3675 119.234 26.7168 116.583 26.7168 113.314V71.8709H133.284V113.314C133.283 116.583 130.633 119.234 127.363 119.234Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.923 110.353H43.0774C42.1707 110.353 41.3888 109.713 41.2118 108.823L36.0523 83.0272C35.8166 81.8496 36.7179 80.7509 37.9179 80.7509H122.081C123.282 80.7509 124.182 81.8496 123.947 83.0272L118.787 108.823C118.61 109.713 117.829 110.353 116.923 110.353Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.96 86.672H77.04V92.592H82.96V86.672Z",
  fill: "#969BB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.1192 86.672H65.1992V92.592H71.1192V86.672Z",
  fill: "#969BB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.2774 86.672H53.3574V92.592H59.2774V86.672Z",
  fill: "#B9BDD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.4376 86.672H41.5176V92.592H47.4376V86.672Z",
  fill: "#B9BDD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.8009 86.672H88.8809V92.592H94.8009V86.672Z",
  fill: "#969BB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.641 86.672H100.721V92.592H106.641V86.672Z",
  fill: "#B9BDD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.483 86.672H112.562V92.592H118.483V86.672Z",
  fill: "#B9BDD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.1192 98.5131H65.1992V104.433H71.1192V98.5131Z",
  fill: "#B9BDD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.96 98.5131H77.04V104.433H82.96V98.5131Z",
  fill: "#B9BDD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.8009 98.5131H88.8809V104.433H94.8009V98.5131Z",
  fill: "#B9BDD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.641 98.5131H100.721V104.433H106.641V98.5131Z",
  fill: "#B9BDD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.2774 98.5131H53.3574V104.433H59.2774V98.5131Z",
  fill: "#B9BDD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.7168 71.8709L46.4971 49.2651C47.0955 48.5813 47.9584 48.1899 48.8672 48.1899H111.134C112.042 48.1899 112.906 48.5824 113.504 49.2651L133.284 71.8709H26.7168Z",
  fill: "url(#paint0_linear_105_50124)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.2793 48.1888L66.9124 40.224C67.4734 39.6384 68.2489 39.3077 69.0596 39.3077H90.6105C91.3988 39.3077 92.155 39.6213 92.7129 40.1781L100.722 48.1877L59.2793 48.1888Z",
  fill: "url(#paint1_linear_105_50124)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.3792 65.3718H68.6208C67.5744 65.3718 66.929 64.2304 67.4677 63.3334L78.8469 44.4011C79.3695 43.5318 80.6304 43.5318 81.153 44.4011L92.5322 63.3334C93.0709 64.2304 92.4245 65.3718 91.3792 65.3718Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.4806 49.2214H78.5195V57.743H81.4806V49.2214Z",
  fill: "#969BB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.9996 62.4523C79.1719 62.4523 78.501 61.7814 78.501 60.9536C78.501 60.1259 79.1719 59.455 79.9996 59.455C80.8274 59.455 81.4983 60.1259 81.4983 60.9536C81.4983 61.7814 80.8274 62.4523 79.9996 62.4523Z",
  fill: "#969BB7"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_105_50124",
  x1: 98.2487,
  y1: 40.2632,
  x2: 66.6791,
  y2: 94.9433,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BABED1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9399B5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_105_50124",
  x1: 86.6972,
  y1: 36.5899,
  x2: 74.82,
  y2: 57.1618,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BABED1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9399B5"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_105_50124"
}, /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 160,
  fill: "white"
})));

var SvgEmptyDtcCodes = function SvgEmptyDtcCodes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyDtcCodes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-dtc-codes.76921a92.svg";
export { ForwardRef as ReactComponent };